import inRange from 'lodash/inRange';

import ApiClient from '../../../helpers/ApiClient';
import { Exercise } from '../../../helpers/fetchExternalExerciseIds';
import { getCampusApiClient } from '../../../helpers/getClients';
import { REQUEST_STATUS } from '../../selectors';

export type LearningRecap = {
  lastActiveDate: Date;
  learningRecap: string;
  lessons: Array<{
    chapterNumber: number;
    id: number;
    number: number;
    title?: string;
  }>;
};

export const getLearningRecapAsPromise = async ({
  courseAsPromise,
  exerciseNumber,
  exercisesAsPromise,
  isPreview,
  preFetchedData,
}: {
  courseAsPromise: Promise<{ id: number }>;
  exerciseNumber: number;
  exercisesAsPromise: Promise<Exercise[]>;
  isPreview: boolean;
  preFetchedData: any;
}): Promise<LearningRecap | null> => {
  const preFetchedDataRequest = preFetchedData.get('learningRecap');
  switch (preFetchedDataRequest.get('status')) {
    case REQUEST_STATUS.SUCCESS:
      return Promise.resolve(preFetchedDataRequest.get('data'));
    case REQUEST_STATUS.FAILED:
      return Promise.reject(preFetchedDataRequest.get('data'));
    default: {
      const course = await courseAsPromise;
      const client = getCampusApiClient();

      if (isPreview) {
        return Promise.resolve(null);
      }

      const exercises = await exercisesAsPromise;
      let nextExerciseNumber: number = exerciseNumber;
      if (!inRange(exerciseNumber - 1, exercises.length)) {
        nextExerciseNumber = 1;
      }

      const nextExerciseId = exercises.find(
        (ex) => ex.number === nextExerciseNumber,
      )?.id;

      if (nextExerciseId === undefined) {
        return Promise.resolve(null);
      }

      return client
        .execute(
          ApiClient.endpoint.getCourseLearningRecap({
            courseId: course.id,
            nextExerciseId,
          }),
        )
        .toPromise()
        .then(({ body: learningRecap }: { body: LearningRecap | null }) => {
          if (learningRecap === null) {
            return null;
          }

          return {
            ...learningRecap,
            lastActiveDate: new Date(learningRecap.lastActiveDate),
          };
        })
        .catch(() => Promise.resolve(null));
    }
  }
};
